const BRAND_GATEWAY_TASKS_SORTING_CRITERIA = {
  MODIFIED_DATE: 'MODIFIED_DATE',
}

export default BRAND_GATEWAY_TASKS_SORTING_CRITERIA
